import { APP_NAME } from '../../../../configuration/constants';

export const PJM_COPIES_PREFIX = `${APP_NAME}.pjm_banner`;

export const PROJECT_PARTNER_IMAGE_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3f97ccff787f9bef859b1012d719e628-1748965522750/project_managers.webp';
